import React from 'react'
import {
    withJsonFormsOneOfEnumProps,
    withTranslateProps,
} from '@jsonforms/react'
import { Autocomplete, TextField, FormHelperText } from '@mui/material'
import { rankWith, and, schemaMatches, uiTypeIs } from '@jsonforms/core'
import { useDynamicConfigs } from '../JsonFormsWrapper'
import { SCHEMA_SHAPE_RANK } from './ranks'

export const dynamicOneOfControlTester = rankWith(
    SCHEMA_SHAPE_RANK,
    and(
        uiTypeIs('Control'),
        // schema for dynamic oneOf compoents is overwritten to match this
        // pattern in getDynamicConfigSchema in pandipackV2
        schemaMatches((schema) => schema.hasOwnProperty('dynamicOneOfKey'))
    )
)

// Borrowed liberally from JSONforms' MaterialOnOfEnumControl renderer
export function DynamicOneOfControl({
    path,
    handleChange,
    label,
    data,
    required,
    schema,
    uischema,
    errors,
    enabled,
}) {
    const dynamicConfigs = useDynamicConfigs()
    const isValid = errors.length === 0
    const loaded = Array.isArray(dynamicConfigs?.[schema.dynamicOneOfKey])
    // Until the configs carry the key there is no way to tell whether the
    // stored value is still valid, so keep it and show it as the only choice.
    const options = loaded
        ? dynamicConfigs[schema.dynamicOneOfKey]
        : data !== undefined && data !== ''
        ? [{ const: data, title: String(data) }]
        : []

    const [inputValue, setInputValue] = React.useState(data ?? '')
    const findOption = options.find((o) => o.const === data) ?? null

    return (
        <>
            <Autocomplete
                disablePortal
                fullWidth
                disabled={!enabled || !loaded || !options.length}
                id={path}
                options={options}
                value={findOption}
                inputValue={inputValue}
                onChange={(_event, newValue) => {
                    handleChange(path, newValue?.const)
                }}
                onInputChange={(_event, newInputValue) => {
                    setInputValue(newInputValue)
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        // fullWidth should be set by the uischema, not the Autocomplete component. This
                        // matches other jsonforms renderers
                        fullWidth={!uischema?.options?.trim}
                        label={label}
                        required={required}
                        error={!isValid}
                    />
                )}
                getOptionLabel={(option) => option.title || ''}
            />
            {!loaded && (
                <FormHelperText>Options have not loaded yet</FormHelperText>
            )}
            {!isValid && <FormHelperText error={true}>{errors}</FormHelperText>}
        </>
    )
}

export default withJsonFormsOneOfEnumProps(
    withTranslateProps(React.memo(DynamicOneOfControl))
)
